import "./Gallery.module.css";
import Header from "@/reusable_sections/Header";
import Showroom from "./sections/Showroom";
import Partners from "./sections/Partners";
import Footer from "@/reusable_sections/Footer";
export default function GalleryPage() {
  return <div>
      <Header />
      <Showroom />
      <Partners />
      <Footer />
    </div>;
}